
// shopify CDN helper methods
export const isCdn = (url) => {
    return url && (url.indexOf('//cdn.shopify.com/') !== -1 || url.indexOf('/cdn/shop/') !== -1);
}

export const cdnSize = (size, fallback = '200x') => {
    if(size === 'small'){
        return '100x';
    } else if(size === 'medium'){
        return '200x';
    } if(size === 'large'){
        return '400x';
    }

    return fallback;
}

export const cdnImg = (url, size) => {
    if(isCdn(url)){
        let extension = url.substring(url.lastIndexOf('.') + 1);
        if('svg' === extension){
            return url; // svg no image resize
        }
        return url.replace('.' + extension, '') + '_' + size + '.' + extension;
    }
    return url;
}